import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'antd';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import p1 from '../../static/partner1.webp';
import p2 from '../../static/partner2.png';
import p3 from '../../static/partner3.png';
import p4 from '../../static/partner4.webp';

const partners = [
  { logo: p1, name: '传善公益咨询' },
  { logo: p2, name: '北京尚善公益基金会' },
  { logo: p3, name: '南都公益基金会' },
  { logo: p4, name: '绿城公益' },
];

const Partners: React.FC = () => {
  const history = useHistory();

  return (
    <PageLayout history={history} children={[]} Content={
      <div className="page-container partners-page">
        <h1 className="page-title">合作伙伴</h1>
        <Row gutter={[32, 32]} justify="start">
          {partners.map((p) => (
            <Col xs={12} sm={8} md={6} key={p.name}>
              <div className="partner-card">
                <div className="partner-card__logo-wrap">
                  <img src={p.logo} alt={p.name} className="partner-card__logo" />
                </div>
                <div className="partner-card__name">{p.name}</div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    } />
  );
};

export default Partners;
